import _extends from "@babel/runtime/helpers/esm/extends";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

/**
 * @file
 * @author dailin01
 */
var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

import React from 'react';
import classNames from 'classnames';
import { ConfigContext } from '../config-provider';
import { cloneElement } from '../_util/reactNode';
import RcMenu from './rc-menu';

var BaseMenu = function BaseMenu(props) {
  var _classNames;

  var customizePrefixCls = props.prefixCls,
      className = props.className,
      _props$mode = props.mode,
      mode = _props$mode === void 0 ? 'horizontal' : _props$mode,
      inlineCollapsed = props.inlineCollapsed,
      expandIcon = props.expandIcon,
      _props$iconList = props.iconList,
      iconList = _props$iconList === void 0 ? [] : _props$iconList,
      scope = props.scope,
      rest = __rest(props, ["prefixCls", "className", "mode", "inlineCollapsed", "expandIcon", "iconList", "scope"]);

  var _React$useContext = React.useContext(ConfigContext),
      getPrefixCls = _React$useContext.getPrefixCls;

  var prefixCls = getPrefixCls('menu', customizePrefixCls);
  var menuClassName = classNames(className, (_classNames = {}, _defineProperty(_classNames, "".concat(prefixCls, "-with-icon"), mode === 'horizontal' && iconList.length), _defineProperty(_classNames, "".concat(prefixCls, "-").concat(scope), scope), _classNames));
  return /*#__PURE__*/React.createElement(RcMenu, _extends({
    prefixCls: prefixCls,
    className: menuClassName,
    expandIcon: cloneElement(expandIcon, {
      className: "".concat(prefixCls, "-submenu-expand-icon")
    }),
    inlineCollapsed: inlineCollapsed,
    mode: mode
  }, rest));
};

export default BaseMenu;